export const DATE_DEFAULT_FORMAT = 'DD.MM.YYYY';
export const DATE_YEARLY_DEFAULT_FORMAT = 'DD.MM';
export const DATETIME_DEFAULT_FORMAT = 'DD.MM.YYYY HH:mm';
export const TIME_DEFAULT_FORMAT = 'HH:mm';
export const ARTICLE_DEFAULT_FORMAT = 'D MMMM, YYYY';
